<template>
  <div>
    <table class="table" :class="tableClass">
      <thead>
        <slot name="columns">
          <th
            v-for="(column, key) in columns"
            :class="'text-' + column.align"
            :key="key"
          >
            {{ column.title }}
          </th>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <!-- v-if="hasValue(item, column.key)" -->
            <td
              v-for="(column, index) in columns"
              :align="column.align ? column.align : 'left'"
              :key="index"
            >
              <checkbox
                @change="changeCheckbox"
                v-if="column.checkbox === true && !column.control"
                v-model="thisChecked"
                :value="item.id"
                color="#ffc107"
                >{{ itemValue(item, column) }}</checkbox>
              
              <div
                class="radio-button"
                v-else-if="column.radio === true && !column.control"
              >
                <input
                  v-model="thisRadio"
                  @change="changeRadio"
                  :id="'item-' + item.id"
                  :value="item.id"
                  :name="'item'"
                  type="radio"
                />
                <label :for="'item-' + item.id">{{
                  itemValue(item, column)
                }}</label>
              </div>

              <div v-else-if="column.remove === true && item.id">
                <button
                  @click="removeItem(item.id)"
                  class="btn btn-sm btn-danger"
                >
                  <span class="ti-trash"></span>
                </button>
              </div>

              <div v-else-if="column.image === true">
                <img :src="itemValue(item, column)" alt />
              </div>
              <div v-else-if="column.link">
                <a :href="column.link + item.id" target="_blank">
                  <span class="ti-link"></span>
                </a>
              </div>
              <div v-else-if="column.timer === true">
                <timer :item="item" />
              </div>
              <span v-else
                ><button
                  v-if="column.detail === true"
                  @click="openLeftMenu(item)"
                  class="mr-2 btn btn-sm btn-info"
                >
                  Смотреть
                </button>
                {{ itemValue(item, column) }}</span
              >
            </td>
          </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import timer from "../components/Timer";

export default {
  components: {
    timer,
  },
  data() {
    return {
      thisChecked: [],
      thisRadio: null,
    };
  },
  name: "paper-table",
  props: {
    columns: Array,
    data: Array,
    checkSet: Array,
    radioSet: {default:null},
    type: {
      type: String,
      default: "striped",
    },
    title: {
      type: String,
      default: "",
    },
    cardLink: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    removeItem: {
      default: function () {},
    },
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
  },
  methods: {
    openLeftMenu(item) {
      let query = Object.assign({}, this.$route.query);
      delete query.id;
      delete query.card;
      this.$router.replace({ query });

      setTimeout(() => {
        this.$router.replace({ query: { card: this.cardLink, id: item.id } });
      }, 20);
    },
    changeRadio(e) {
      this.$emit("changeRadio", this.thisRadio);
    },
    changeCheckbox(e) {
      this.$emit("changeCheckbox", this.thisChecked);
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      let key = column.key;
      if (typeof item[key] === "object" && item[key] !== null) {
        let titleObject = item[key];
        if (titleObject.length) {
          return titleObject
            .map(function (elem) {
              if (elem.title) {
                return elem.title;
              } else if (elem.name) {
                return elem.name;
              }
            })
            .join(", ");
        }
        if (titleObject.id) {
          if (titleObject.title) {
            return titleObject.title;
          } else if (titleObject.name) {
            return titleObject.name;
          }
        } else {
          return "Нет данных";
        }
      }
      if (typeof item[key] === "array" && item[key].length) {
        return 2;
      }

      if (item[key.toLowerCase()] || item[key.toLowerCase()] === 0) {
        return item[key.toLowerCase()];
      }
      return "Нет данных";
    },
  },
  created() {},
  watch: {
    checkSet(val) {
      if (val && val.length === 0) {
        this.thisChecked = [];
      }
    },
    radioSet(val) {
      if (val) {
        this.thisRadio = null;
      }
    },
  },
};
</script>
<style>
</style>
